import PropTypes from "prop-types";
import {useDispatch} from "react-redux";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {submit} from "redux-form";
import React from "react";
import ExternalOfferForm from "./ExternalOfferForm";

const ExternalOfferDialog = ({open, onSubmit, initialValues, onCancel, submitting, loading, edit}) => {

  const dispatch = useDispatch();

  return (
    <Dialog open={open} fullWidth={true} onClose={onCancel}>
      <DialogTitle>{edit ? "Edycja oferty" : "Nowa oferta"}</DialogTitle>
      <DialogContent>
        {loading && <div style={{textAlign: "center"}}>
          <CircularProgress/>
        </div>}
        {!loading && <ExternalOfferForm initialValues={initialValues} onSubmit={onSubmit}/>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>
          Anuluj
        </Button>
        <Button variant="contained" onClick={() => dispatch(submit('externalOfferForm'))} disabled={submitting}
                color="primary">
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ExternalOfferDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  initialValues: PropTypes.object,
  edit: PropTypes.bool,
};
ExternalOfferDialog.defaultProps = {
  edit: false,
  initialValues: {
    description: '',
    url: ''
  }
}

export default ExternalOfferDialog;
